// extracted by mini-css-extract-plugin
export default {"p_content":"d4322024fb"};